;(() => {
  const MAX_TIMEOUT_DELAY = 2 ** 31 - 1
  const DEFAULT_DELAY = Turbo.config.drive.progressBarDelay

  document.addEventListener("turbo:submit-start", (event) => {
    const { formElement, submitter } = event.detail.formSubmission
    const acceptsStream = [submitter, formElement].some((element) =>
      element?.hasAttribute("data-turbo-stream"),
    )
    if (!acceptsStream) return

    Turbo.config.drive.progressBarDelay = MAX_TIMEOUT_DELAY
    formElement.addEventListener(
      "turbo:submit-end",
      () => {
        Turbo.config.drive.progressBarDelay = DEFAULT_DELAY
      },
      { once: true },
    )
  })
})()
